import { render, staticRenderFns } from "./foodPackStock.vue?vue&type=template&id=b010dcf0&scoped=true&"
import script from "./foodPackStock.vue?vue&type=script&lang=js&"
export * from "./foodPackStock.vue?vue&type=script&lang=js&"
import style0 from "./foodPackStock.vue?vue&type=style&index=0&id=b010dcf0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b010dcf0",
  null
  
)

export default component.exports